import { Output, EventEmitter, Input, Directive } from '@angular/core';

import { Column } from '../../lib/data-set/column';
import { DataSource } from '../../lib/data-source/data-source';

@Directive()
export class FilterDefault {
  @Input() column: Column;
  @Input() source: DataSource;
  @Input() inputClass: string = '';

  @Output() filter = new EventEmitter<any>();

  query: string = '';
  filterType: any;

  onFilter(query: string) {
    if (this.column.cached) {
      this.column.cached = false;
      const filterModel = this.source.getFilter();
      if (filterModel) {
        filterModel.filters.find(
          item => item.field === this.column.id,
        ).cached = false;
      }
    } else {
      if (this.column.filter) {
        this.filterType = this.column.filter.type;
      } else {
        this.filterType = this.column.getFilterFunction();
      }
      this.source.addFilter({
        field: this.column.id,
        search: query,
        filter: this.filterType,
      });
    }
  }
}
